import { useQuery } from '@tanstack/react-query';
import type { AuthUserDto } from '@shared/api-contracts';

import { getQueryFn } from '@/lib/queryClient';

export type AuthUser = AuthUserDto;

export function useAuth() {
  const { data: user, isLoading } = useQuery<AuthUser | null>({
    queryKey: ['/api/auth/user'],
    queryFn: getQueryFn({ on401: 'returnNull' }),
    // Inherit the central retry: a cold-start 5xx retries (so a logged-in user
    // isn't shown as logged out during a DB wake); 401 returns null and never retries.
    refetchOnWindowFocus: true, // Refetch when window regains focus (helps with social login redirects)
  });

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
  };
}
